import { QueryClient, keepPreviousData } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 60 * 60 * 1000,
            staleTime: 60_000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 1,
            placeholderData: keepPreviousData,
            structuralSharing: true,
        },
    },
});

declare global {
    interface Window {
        __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
    }
}

window.__TANSTACK_QUERY_CLIENT__ = queryClient;
